import { useEffect, useState } from 'react';

const EVENTS = ['pointerdown', 'keydown', 'touchstart', 'scroll'];

/**
 * Turns `true` on the visitor's first interaction, or after `timeout` ms without any,
 * so non-essential third parties can wait until the page has rendered and settled.
 */
export const useFirstInteraction = (timeout) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (ready) return;
    const trigger = () => setReady(true);
    const timer = setTimeout(trigger, timeout);
    EVENTS.forEach((event) =>
      window.addEventListener(event, trigger, { once: true, passive: true }),
    );
    return () => {
      clearTimeout(timer);
      EVENTS.forEach((event) => window.removeEventListener(event, trigger));
    };
  }, [ready, timeout]);

  return ready;
};
